module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "left"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('success.congratulations')))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('success.found', {
    points: _vm.points
  })) + "\n      "), (_vm.points === 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('success.keepItUp')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "label label--for-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expertMode),
      expression: "expertMode"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.expertMode) ? _vm._i(_vm.expertMode, null) > -1 : (_vm.expertMode)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.expertMode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.expertMode = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.expertMode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.expertMode = $$c
        }
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('config.expertMode')) + "\n        "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$t('config.expertModeDescription')))])])]), _vm._v(" "), _c('div', {
    staticClass: "label label--for-select"
  }, [_c('label', [_vm._v("\n        " + _vm._s(_vm.$t('config.findA')) + "\n        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.animal),
      expression: "animal"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.animal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.unlockedAnimals), function(animal) {
    return _c('option', {
      domProps: {
        "value": animal.key
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t(("animal." + (animal.key)))) + "\n          ")])
  }))])]), _vm._v(" "), (_vm.points < _vm.ANIMALS[1].pointsRequired) ? _c('small', {
    staticClass: "tip",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('success.unlockAtFive'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.points >= _vm.ANIMALS[1].pointsRequired && _vm.points < _vm.ANIMALS[2].pointsRequired) ? _c('small', {
    staticClass: "tip",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('success.unlockAtFifty'))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.points >= _vm.ANIMALS[2].pointsRequired) ? _c('small', {
    staticClass: "tip",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('success.unlockedAll'))
    }
  }) : _vm._e(), _vm._v(" "), _c('find-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.setPage(_vm.PAGE_GAME)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('cta.findA', {
    animal: _vm.$t(("animal." + _vm.animal))
  })) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('find-social-button', {
    attrs: {
      "network": "facebook"
    }
  }), _vm._v(" "), _c('find-social-button', {
    attrs: {
      "network": "twitter"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('ins', {
    staticClass: "adsbygoogle",
    staticStyle: {
      "width": "300px",
      "height": "250px"
    },
    attrs: {
      "data-ad-client": "ca-pub-7708254463438007",
      "data-ad-slot": "2580619829"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30a6ec88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Congratulations.vue
// module id = 177
// module chunks = 2